export default __webpack_public_path__ + "static/media/keells-logo-loader.4571eb73.png";